var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 18V14C42 10.7 39.3 8 36 8H12C8.7 8 6 10.7 6 14V18C2.7 18 0 20.7 0 24V34C0 37.3 2.7 40 6 40H42C45.3 40 48 37.3 48 34V24C48 20.7 45.3 18 42 18ZM10 14C10 12.9 10.9 12 12 12H36C37.1 12 38 12.9 38 14V19.56C36.78 20.66 36 22.24 36 24V28H12V24C12 22.24 11.22 20.66 10 19.56V14ZM44 34C44 35.1 43.1 36 42 36H6C4.9 36 4 35.1 4 34V24C4 22.9 4.9 22 6 22C7.1 22 8 22.9 8 24V32H40V24C40 22.9 40.9 22 42 22C43.1 22 44 22.9 44 24V34Z",
    fill: "#127FBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPp);
export default __webpack_public_path__ + "static/media/pp.f9e01771eaa187534be4a78658127155.svg";
export { ForwardRef as ReactComponent };